import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { IEBreakPoints } from 'theme/@types';
import Textrure from './assets/texture.png';

const ErrorsViewWrapper = styled(Box)({
  borderColor: 'transparent',
  padding: '20px 10px',
  textAlign: 'center',
  minHeight: '100%',
  minWidth: '100%',
  backgroundImage: `url(${Textrure})`,
});

const ErrorsViewContent = styled(Box)(({ theme }) => ({
  borderColor: 'transparent',
  padding: '20px 50px',
  textAlign: 'center',
  width: '100%',
  maxWidth: 400,
  margin: '0 auto',

  'svg.svgBaby': {
    maxWidth: '50%',
    height: 'auto',
    display: 'block',
    margin: '10px auto 30px auto',
  },

  [theme.breakpoints.up(IEBreakPoints.LAPTOP)]: {
    'svg.svgBaby': {
      maxWidth: '100%',
    },
  },
}));

export default ErrorsViewWrapper;
export { ErrorsViewContent };
